<app-navmenu></app-navmenu>
<router-outlet></router-outlet>
<app-footer></app-footer>

<!-- removed as per discussion on 27th April 2022 -->
<!-- <div class="float-button-login" id="client">
    <a type="button" class="btn btn-lg btn-primary ml-3 mr-3" href="https://dms.sficompliance.com"
      target="_blank"><i class="fa fa-globe"></i>&nbsp;LOGIN</a>
  </div> -->

<!-- <div class="float-button">
    <a type="button" class="btn btn-lg btn-danger ml-3 mr-3" target="_blank" href="{{chatLink}}"><i
            class="fa fa-comment-o"></i>&nbsp;Chat</a>
</div> -->

<!-- <div class="float-button">
    <a type="button" class="btn btn-lg btn-secondary ml-3 mr-3" href="/faq"><i
            class="fa fa-question"></i>&nbsp;FAQ</a>
</div> -->